export const APPEARANCE_PREFERENCE = 'READNG_APPEARANCE_PREFERENCE';
export const MODE_DARK = 'Dark';
export const MODE_LIGHT = 'Light';
export const MODE_SYSTEM_DEFAULT = 'System default';
